<template>
  <div class="charts-wrapper">
    <div class="charts-toolbar-panel">
      <div class="left-ba"></div>
      <div class="right-bar">
        <button
          :class="{ active: activePeriodFilter === 'week' }"
          :disabled="hasDatesDiff(chartsData[0].data, 'week')"
          type="button"
          class="chart-period-filter-btn"
          @click="handlePeriodFilterBtnClick('week')"
        >
          Н
        </button>
        <button
          :class="{ active: activePeriodFilter === 'month' }"
          :disabled="hasDatesDiff(chartsData[0].data, 'month')"
          type="button"
          class="chart-period-filter-btn"
          @click="handlePeriodFilterBtnClick('month')"
        >
          М
        </button>
        <button
          :class="{ active: activePeriodFilter === 'year' }"
          :disabled="hasDatesDiff(chartsData[0].data, 'year')"
          type="button"
          class="chart-period-filter-btn"
          @click="handlePeriodFilterBtnClick('year')"
        >
          Г
        </button>
      </div>
    </div>

    <div class="top-apex-shart">
      <div class="chart-annotation">n куб. м<sup>3</sup></div>
      <apexchart :options="chartOptionsArea" :series="chartsData" type="bar" height="200" />
    </div>
    <div>
      <apexchart :options="chartOptionsBrush" :series="chartsData" type="area" height="115" />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import ruLocale from "../../common/apexcharts/ru.json";

export default {
  name: "ContainerCharts",
  props: {
    chartsData: {
      type: Array,
      default: () => [
        {
          data: []
        }
      ]
    }
  },
  data() {
    return {
      activePeriodFilter: "week",
      chartOptionsArea: {
        chart: {
          id: "chartArea",
          locales: [ruLocale],
          defaultLocale: "ru",
          toolbar: {
            autoSelected: "pan",
            show: false
          },
          animations: {
            enabled: false
          }
        },
        colors: ["#68A4FF"],
        stroke: {
          width: 2
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 1
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime",
          labels: {
            show: false
          },
          axisTicks: {
            show: false
          },
          axisBorder: {
            color: "#EDEDED"
          }
        },
        yaxis: {
          tickAmount: 6,
          min: 0,
          labels: {
            show: false
          }
        },
        tooltip: {
          style: {
            fontFamily: "'Open Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
          },
          x: {
            formatter: date => {
              const newDate = new Date(date);
              const monthA = "января,февраля,марта,апреля,мая,июня,июля,августа,сентября,октября,ноября,декабря".split(",");

              return `${moment(date).format("dddd, D")} ${monthA[newDate.getMonth()]}`;
            }
          },
          y: [
            {
              title: {
                formatter: () => {}
              },
              formatter: function(value) {
                return `${value.toFixed(2)} куб. м./сутки`;
              }
            }
          ]
        },
        states: {
          hover: {
            filter: {
              type: "lighten",
              value: 0.05
            }
          }
        },
        grid: {
          yaxis: {
            lines: {
              show: true
            }
          }
        }
      },
      chartOptionsBrush: {
        chart: {
          id: "chartBrush",
          locales: [ruLocale],
          defaultLocale: "ru",
          brush: {
            target: "chartArea",
            enabled: true
          },
          events: {
            click: this.handleBrushChartClick
          },
          selection: {
            enabled: true,
            fill: {
              color: "#CCE0FF",
              opacity: 0.19
            },
            stroke: {
              dashArray: 0,
              color: "#5C9DFF",
              opacity: 1
            }
          }
        },
        colors: ["#68A4FF"],
        dataLabels: {
          enabled: false
        },
        fill: {
          type: "solid",
          opacity: 0.4,
          colors: ["#CCE0FF"]
        },
        xaxis: {
          type: "datetime",
          tooltip: {
            enabled: false
          },
          axisTicks: {
            color: "#EFEFEF"
          },
          axisBorder: {
            color: "#EFEFEF"
          },
          labels: {
            datetimeFormatter: {
              month: "MMM"
            },
            style: {
              fontFamily: "'Open Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
            }
          }
        },
        yaxis: {
          tickAmount: 6,
          min: 0,
          labels: {
            show: false
          }
        },
        grid: {
          borderColor: "#EFEFEF",
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        }
      }
    };
  },
  watch: {
    chartsData: function(newChartsData) {
      if (Array.isArray(newChartsData[0].data) && newChartsData[0].data.length > 2) {
        const lastDate = newChartsData[0].data.slice(-1)[0][0];

        this.chartOptionsBrush = {
          ...this.chartOptionsBrush,
          chart: {
            ...this.chartOptionsBrush.chart,
            selection: {
              ...this.chartOptionsBrush.chart.selection,
              xaxis: {
                min: moment(lastDate)
                  .subtract(1, "week")
                  .valueOf(),
                max: lastDate
              }
            }
          }
        };
      }
    }
  },
  created() {
    if (this.chartsData[0].data.length !== 0) {
      const lastDate = this.chartsData[0].data.slice(-1)[0][0];

      this.chartOptionsBrush = {
        ...this.chartOptionsBrush,
        chart: {
          ...this.chartOptionsBrush.chart,
          selection: {
            ...this.chartOptionsBrush.chart.selection,
            xaxis: {
              min: moment(lastDate)
                .subtract(1, "week")
                .valueOf(),
              max: lastDate
            }
          }
        }
      };
    }
  },
  methods: {
    handlePeriodFilterBtnClick(type) {
      const firstDate = this.chartsData[0].data[0][0];
      const lastDate = this.chartsData[0].data.slice(-1)[0][0];
      let minXaxis = null;

      switch (type) {
        case "week":
          minXaxis = moment(lastDate)
            .subtract(1, "week")
            .valueOf();
          break;
        case "month":
          minXaxis = moment(lastDate)
            .subtract(1, "month")
            .valueOf();
          break;
        case "year":
          minXaxis = firstDate;
          break;
        default:
          return;
      }

      this.activePeriodFilter = type;

      this.chartOptionsBrush = {
        ...this.chartOptionsBrush,
        chart: {
          ...this.chartOptionsBrush.chart,
          selection: {
            ...this.chartOptionsBrush.chart.selection,
            xaxis: {
              min: minXaxis,
              max: lastDate
            }
          }
        }
      };
    },
    hasDatesDiff(dates, compType) {
      if (Array.isArray(dates) && dates.length > 2 && typeof compType !== "undefined") {
        const firstDate = this.chartsData[0].data[0][0];
        const lastDate = this.chartsData[0].data.slice(-1)[0][0];

        switch (compType) {
          case "week":
            return moment(lastDate).diff(moment(firstDate), "days") < 7;
          case "month":
            return moment(lastDate).diff(moment(firstDate), "months") < 1;
          case "year":
            return moment(lastDate).diff(moment(firstDate), "weeks") < 51;
          default:
            return true;
        }
      }

      return true;
    },
    handleBrushChartClick() {
      this.activePeriodFilter = null;
    }
  }
};
</script>
